import { EXTERNAL_PRODUCT_STATUS } from '@app/pages/ExternalProductsCatalogPage/сonstans'

import type { ExternalProductStatus } from '@app/shared/types'

interface GetExternalProductStatusParams {
  isConfirmed: boolean | null
  isMatchedWithProduct: boolean | null
}

export const getExternalProductStatus = ({
  isConfirmed,
  isMatchedWithProduct
}: GetExternalProductStatusParams): ExternalProductStatus => {
  if (isConfirmed && isMatchedWithProduct) return EXTERNAL_PRODUCT_STATUS.confirmedByLenta

  if (isConfirmed) return EXTERNAL_PRODUCT_STATUS.confirmed

  return EXTERNAL_PRODUCT_STATUS.notConfirmed
}
